import {
  LOCAL_ADD_WORK_INSTRUCTION_PACKAGE,
  LOCAL_DELETE_WORK_INSTRUCTION_PACKAGE,
  LOCAL_ADD_WORK_INSTRUCTION,
  LOCAL_UPDATE_WORK_INSTRUCTION,
  LOCAL_DELETE_WORK_INSTRUCTION,
  LOCAL_ADD_WORK_INSTRUCTION_STEP,
  LOCAL_UPDATE_WORK_INSTRUCTION_STEP,
  LOCAL_DELETE_WORK_INSTRUCTION_STEP,
  LOCAL_SET_WORK_INSTRUCTION_PACKAGES,
  LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE,
  LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP,
  LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP,
  LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION,
  LOCAL_SET_TASKS_TO_WORK_INSTRUCTION,
  LOCAL_SIGN_OFF_STEP,
  LOCAL_CHANGE_WORK_INSTRUCTION_STEPS_ORDER,
  LOCAL_CHANGE_WORK_INSTRUCTIONS_ORDER,
  LOCAL_SET_JOB_WORK_INSTRUCTION_STATUS,
} from '../mutations/mutationTypes';

import client from '../../../config/api';

import loadJobWorkInstructionStatus from '../../../helpers/workInstructions/loadJobWorkInstructionStatus';

export default {
  ADD_WORK_INSTRUCTION_PACKAGE({ commit }, payload) {
    client.post('/work-instructions-package', payload);

    commit(LOCAL_ADD_WORK_INSTRUCTION_PACKAGE, payload);
  },

  FETCH_WORK_INSTRUCTION_PACKAGES: async ({ commit }, jobId) => {
    const response = await client.get(
      `/work-instructions-package/job/${jobId}`
    );

    const packages = response.data;

    commit(LOCAL_SET_WORK_INSTRUCTION_PACKAGES, packages);
  },

  DELETE_WORK_INSTRUCTION_PACKAGE({ commit }, { packageId }) {
    client.delete(`/work-instructions-package/${packageId}`);

    commit(LOCAL_DELETE_WORK_INSTRUCTION_PACKAGE, { packageId });
  },

  async ADD_WORK_INSTRUCTION({ commit }, payload) {
    await client.post(
      `/work-instructions/package/${payload.packageId}`,

      payload
    );

    commit(LOCAL_ADD_WORK_INSTRUCTION, payload);
  },

  async UPDATE_WORK_INSTRUCTION({ commit }, payload) {
    await client.put(`/work-instructions/${payload._id}`, payload);

    commit(LOCAL_UPDATE_WORK_INSTRUCTION, payload);
  },

  DELETE_WORK_INSTRUCTION({ commit }, { instructionId }) {
    client.delete(`/work-instructions/${instructionId}`);

    commit(LOCAL_DELETE_WORK_INSTRUCTION, { instructionId });
  },

  ADD_WORK_INSTRUCTION_STEP({ commit }, payload) {
    client.post(
      `/work-instructions/step/${payload.instructionId}`,

      payload.step
    );

    commit(LOCAL_ADD_WORK_INSTRUCTION_STEP, {
      instructionId: payload.instructionId,

      step: payload.step,
    });
  },

  UPDATE_WORK_INSTRUCTION_STEP({ commit }, payload) {
    client.put(
      `/work-instructions/step/${payload.instructionId}/${payload.step._id}`,

      payload.step
    );

    commit(LOCAL_UPDATE_WORK_INSTRUCTION_STEP, {
      instructionId: payload.instructionId,

      step: payload.step,
    });
  },

  DELETE_WORK_INSTRUCTION_STEP({ commit }, { instructionId, stepId }) {
    client.delete(`/work-instructions/step/${instructionId}/${stepId}`);

    commit(LOCAL_DELETE_WORK_INSTRUCTION_STEP, {
      instructionId,

      stepId,
    });
  },

  FETCH_WORK_INSTRUCTIONS_FOR_PACKAGE: async ({ commit }, packageId) => {
    const response = await client.get(
      `/work-instructions/package/${packageId}`
    );

    const workInstructions = response.data;

    commit(LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE, workInstructions);
  },

  LINK_FILES_TO_WORK_INSTRUCTION_STEP(
    { commit },

    { instructionId, files, stepId }
  ) {
    const fileIds = files.map((entry) => entry._id);

    client.post(`/work-instructions/link-files/${instructionId}`, {
      fileIds,

      stepId,
    });

    commit(LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP, {
      instructionId,

      files,

      stepId,
    });
  },

  LINK_TASKS_TO_WORK_INSTRUCTION_STEP(
    { commit },

    { instructionId, tasks, stepId }
  ) {
    const taskIds = tasks.map((entry) => entry._id);

    client.post(`/work-instructions/link-tasks/${instructionId}`, {
      taskIds,

      stepId,
    });

    commit(LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP, {
      instructionId,

      tasks,

      stepId,
    });
  },

  LINK_FILES_TO_WORK_INSTRUCTION({ commit }, { instructionId, files }) {
    const fileIds = files.map((entry) => entry._id);

    client.post(`/work-instructions/link-files-to-wi/${instructionId}`, {
      fileIds,
    });

    commit(LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION, {
      instructionId,

      files,
    });
  },

  LINK_TASKS_TO_WORK_INSTRUCTION({ commit }, { instructionId, tasks }) {
    const taskIds = tasks.map((entry) => entry._id);

    client.post(`/work-instructions/link-tasks-to-wi/${instructionId}`, {
      taskIds,
    });

    commit(LOCAL_SET_TASKS_TO_WORK_INSTRUCTION, { instructionId, tasks });
  },

  CHANGE_WORK_INSTRUCTION_STEPS_ORDER(
    { commit },

    { instructionId, stepId, targetStepId }
  ) {
    client.put(`/work-instructions/steps-order/${instructionId}`, {
      stepId,

      targetStepId,
    });

    commit(LOCAL_CHANGE_WORK_INSTRUCTION_STEPS_ORDER, {
      instructionId,

      stepId,

      targetStepId,
    });
  },

  CHANGE_WORK_INSTRUCTIONS_ORDER(
    { commit },

    { instructionId, targetInstructionId }
  ) {
    client.put(`/work-instructions/instructions-order/${instructionId}`, {
      targetInstructionId,
    });

    commit(LOCAL_CHANGE_WORK_INSTRUCTIONS_ORDER, {
      instructionId,

      targetInstructionId,
    });
  },

  SIGN_OFF_STEP(
    { commit },

    { instruction, step, timestamp, userFullName, userId }
  ) {
    client.post(`/work-instructions/sign-off/${instruction._id}`, {
      stepId: step._id,

      timestamp,

      userFullName,

      userId,
    });

    commit(LOCAL_SIGN_OFF_STEP, {
      instruction,

      step,

      timestamp,

      userFullName,

      userId,
    });
  },

  FETCH_JOB_WORK_INSTRUCTION_STATUS: async ({ commit, state }, jobId) => {
    if (!jobId) {
      return;
    }

    if (
      state.jobWorkInstructionStatus.loading &&
      state.jobWorkInstructionStatus.jobId === jobId
    ) {
      return;
    }

    const isSameJob = state.jobWorkInstructionStatus.jobId === jobId;

    commit(LOCAL_SET_JOB_WORK_INSTRUCTION_STATUS, {
      jobId,

      loading: true,

      statusLoaded: false,

      ...(isSameJob
        ? {}
        : {
            hasInstructions: false,

            instructionCount: 0,
          }),
    });

    try {
      const { hasInstructions, instructionCount } =
        await loadJobWorkInstructionStatus(client, jobId);

      commit(LOCAL_SET_JOB_WORK_INSTRUCTION_STATUS, {
        jobId,

        hasInstructions,

        instructionCount,

        loading: false,

        statusLoaded: true,
      });
    } catch (error) {
      commit(LOCAL_SET_JOB_WORK_INSTRUCTION_STATUS, {
        jobId,

        hasInstructions: false,

        instructionCount: 0,

        loading: false,

        statusLoaded: true,
      });
    }
  },
};
